import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import * as Actions from '../redux/actions';

import FlyoutView from './FlyoutView';
import SensorDetailContainer from './Components/Detail/SensorDetailContainer';
import SensorModuleDetailContainer from './Components/Detail/SensorModuleDetailContainer';


class FlyoutContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  close(detail) {
    const { dispatch } = this.props;
    dispatch(Actions.Detail.dismiss(detail.stackId));
  }

  detailViewFactory(detail, orgId) {
    const {
      data = {},
      handleClose = () => this.close(detail),
      dataType,
      stackId,
      parentStackId,
    } = detail;

    console.log(detail);

    switch (dataType) {
      case Actions.Detail.DATA_TYPE_SENSOR: {
        const {
          sensor = {},
          locations = [],
          mode,
        } = data || {};

        return (
          <SensorDetailContainer
            mode={mode}
            handleClose={handleClose}
            orgId={orgId}
            sensor={sensor}
            locations={locations}
            stackId={stackId}
            parentStackId={parentStackId}
          />);
      }
      case Actions.Detail.DATA_TYPE_SENSOR_MODULE: {
        const {
          sensor = {},
          module = {},
        } = data || {};

        return (
          <SensorModuleDetailContainer
            handleClose={handleClose}
            orgId={orgId}
            sensor={sensor}
            module={module}
            stackId={stackId}
            parentStackId={parentStackId}
          />);
      }
      default:
        return null;
    }
  }

  generateFlyoutComponents(props) {
    const { flyoutStack } = props;

    let pushedByCount = 0;
    return _.map(flyoutStack, (detail, i) => {
      const {
        data,
        dataType,
        loading,
        updating,
        error,
        stackId,
        parentStackId,
      } = detail;
      const visible = !_.isEmpty(detail);
      const totalFlyoutCount = flyoutStack.length;

      // Keep track of how many are visible
      // currentPushedByCount will tell you how many flyouts are stacked to the right of you
      const currentPushedByCount = pushedByCount;
      // Update after making a copy
      pushedByCount += visible ? 1 : 0;

      return (
        <FlyoutView
          key={i}
          pushedByCount={currentPushedByCount}
          totalFlyoutCount={totalFlyoutCount}
          stackIndex={i}
          stackId={stackId}
          parentStackId={parentStackId}
          visible={visible}
          data={data}
          dataType={dataType}
          loading={loading}
          updating={updating}
          error={error}
          handleClose={() => this.close(detail)}
          handleCreateInnerView={() => this.detailViewFactory(detail, props.orgId)}
        />);
    });
  }

  render() {
    return (
      <div className='flyout-container'>
        { this.generateFlyoutComponents(this.props) }
      </div>);
  }
}

FlyoutContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

FlyoutContainer.defaultProps = {};

const mapStateToProps = state => ({
  flyoutStack: state.detail.stack,
});

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(FlyoutContainer);



// WEBPACK FOOTER //
// ./src/views/FlyoutContainer.js